import { useNode, useEditor } from "@craftjs/core";
import React, { useContext, useEffect } from "react";
import GrigoraCSSRenderer from "./../css-render";
import { PostContentSettings } from "./settings";
import parse from "html-react-parser";
import icon from "./icon";
import classnames from "classnames";
import { getDynamicCSS, getSupportProps } from "../../block-supports";
import { GrigoraDashboardContext } from "../../dashboard/context";
import { toast } from "react-toastify";
import Toast from "../../toast/toast";

export const PostContent = (props) => {
  const { cmsPosts } = useContext(GrigoraDashboardContext) ?? {};
  const {
    id,
    connectors: { connect, drag },
    selected,
  } = useNode((state) => ({
    id: state.id,
    selected: state.events.selected,
    dragged: state.events.dragged,
  }));

  const { content = "", linkPost, openInNewTab, link = "#" } = props;

  var blockProps = getSupportProps({
    id,
    ...props,
  });

  const wrapperClass = classnames(
    {
      "g-post-content": true,
      [`post-content-${id}`]: id,
    },
    blockProps.className,
  );

  useEffect(() => {
    if (selected) {
      return;
    }
  }, [selected]);

  return (
    <div
      {...blockProps}
      ref={(ref) => connect(drag(ref))}
      onClick={(e) => {
        // On double click
        if (e.detail === 2) {
          toast.info(<Toast title={"Post Content is non editable block"} />, {
            // icon: <CorrectIcon />,
          });
          return;
        }
      }}
      className={wrapperClass}
      data-grigora-block="true"
      data-grigora-block-id={id}
    >
      <style>{`${getDynamicCSS(id, props)}`}</style>
      <style>{`${GrigoraCSSRenderer.blockCSS__PostContent(id, props)}`}</style>
      {linkPost ? (
        <a
          onClick={(e) => {
            e.preventDefault();
          }}
          className="post-content-link"
          target={`${openInNewTab == true ? "_blank" : "_self"}`}
          href={link}
        >
          This will be replaced by post content.
        </a>
      ) : (
        <>This will be replaced by post content.</>
      )}
      {props.children}
    </div>
  );
};

// To Avoid Mangling in Production
PostContent.displayName = "PostContent";

PostContent.craft = {
  name: "Post Content",
  props: {},
  related: {
    settings: PostContentSettings,
    icon: icon,
    supports: [
      "grigora/entrance-animations",
      "grigora/css-transform-animations",
      "grigora/mouse-movement",
      "grigora/visibility",
      "grigora/position",
      "grigora/sticky",
      "grigora/filter",
      "grigora/custom-class",
      "grigora/custom-id",
    ],
    category: "cms",
  },
  custom: {
    name: "Post Content",
    slug: "grigora/post-content",
  },
};
